<template>
  <main ref="scrollRef"
        class="home-content">
    <!-- 导航 -->
    <header>
      <HeaderMenu :is-home="true"></HeaderMenu>
    </header>

    <!-- 主标题 - 页面唯一的 h1 -->
    <h1 class="visually-hidden">Flashbase - 定制您的专属产品</h1>

    <!-- 轮播图区域 -->
    <section class="carousel"
             aria-label="精彩轮播">
      <Swiper :modules="modules"
              :slides-per-view="1"
              :loop="true"
              :autoplay="{ disableOnInteraction: false, delay: 5000 }"
              :pagination="{ el: '.pagination', clickable: true }">
        <swiper-slide v-for="(slideContent, index) in slides"
                      :key="index"
                      :virtual-index="index"
                      :style="{ background: `url('${slideContent}') no-repeat center center/cover`, backgroundSize: 'cover' }">
        </swiper-slide>
      </Swiper>
      <div class="pagination"
           role="navigation"
           aria-label="轮播图导航"></div>
    </section>

    <!-- 特色服务区域 -->
    <section class="icon"
             aria-label="我们的特色服务">
      <div v-for="(item, index) in icon_list"
           :key="index"
           class="icon-item">
        <div :style="{ background: `url(${item.image}) left 100% no-repeat`, backgroundSize: 'cover' }"
             class="icon-icon"
             aria-hidden="true"></div>
        <span class="icon-title">{{ item.title }}</span>
      </div>
    </section>

    <!-- 业务介绍 -->
    <section class="process"
             aria-label="一站式定制流程">
      <div class="process-box">
        <h2 class="title">{{ $t('home.Home.processTitle') }}</h2>
        <p class="title-en">One-stop customization process</p>
        <p class="subtitle">{{ $t('home.Home.processSubTitle') }}</p>
        <!-- <button class="process-btn"
                @click="goDesign"
                aria-label="开始设计">
          <span>{{ $t('home.Home.goDesign') }}</span>
          <div class="icon-arrow"
               aria-hidden="true"></div>
        </button> -->
      </div>

      <div class="process-flex"
           role="list">
        <article v-for="(item, index) in process_container"
                 :key="index"
                 class="process-item"
                 role="listitem">
          <div :class="designFlag && designTitle == item.flag ? 'process-design' : ''"
               class="process-design"
               @mouseover="changeDesign(true, item.flag)"
               @mouseout="changeDesign(false, item.flag)">
            <img :src="item.icon"
                 :class="designFlag && designTitle == item.flag ? 'process-hover' : ''"
                 class="process-icon"
                 :alt="item.title + '图标'" />
            <img :src="item.image"
                 :class="designFlag && designTitle == item.flag ? 'process-hover' : ''"
                 class="process-image"
                 :alt="item.title" />
            <div class="process-bottom"
                 :class="designFlag && designTitle == item.flag ? 'process-hover-title' : ''">
              <h3 class="process-title">{{ item.title }}</h3>
              <p class="process-desc">{{ item.desc }}</p>
            </div>
          </div>
        </article>
      </div>
    </section>

    <!-- 热销产品 -->
    <section class="category"
             aria-label="热销产品">
      <div class="categoryGrid">
        <div>
          <article class="categoryImageBox">
            <img ref="imageRef"
                 :src="categoryBg"
                 class="categoryImage"
                 @load="onImageLoad"
                 alt="热销产品展示" />
            <div class="categoryBg">
              <div>
                <h2 class="categoryTitle">{{ $t('home.Home.categoryTitle') }}</h2>
                <p class="categorySubTitle">Hot products are easily customized</p>
                <button class="categoryBtn"
                        @click="goCategory"
                        aria-label="查看更多产品">
                  <span>{{ $t('home.Home.goCategory') }}</span>
                  <div class="icon-arrow"
                       aria-hidden="true"></div>
                </button>
              </div>
            </div>
          </article>
          <article ref="boxRef"
                   class="categoryBox"
                   :style="{ height: categoryHeight }">
            <div class="hoodie"
                 aria-hidden="true"></div>
            <div>
              <h3 class="categoryBoxTitle">{{ $t('home.Home.hoodieSeries') }}</h3>
              <p class="categoryoxSubTitle">Hoodie series</p>
              <div class="categoryBoxLine"
                   aria-hidden="true"></div>
            </div>
          </article>
        </div>
        <div>
          <article class="categoryBox"
                   :style="{ height: categoryHeight }"
                   style="background-color:#EDEDED;">
            <div class="windbreaker"
                 aria-hidden="true"></div>
            <div>
              <h3 class="categoryBoxTitle">{{ $t('home.Home.parkasSeries') }}</h3>
              <p class="categoryoxSubTitle">Windbreaker series</p>
              <div class="categoryBoxLine"
                   aria-hidden="true"></div>
            </div>
          </article>
          <article class="categoryCenterImageBox">
            <img :src="categoryPolo"
                 class="categoryCenterImage"
                 alt="Polo衫系列" />
            <div class="categoryCenterBox">
              <h3 class="categoryBoxTitle">{{ $t('home.Home.polo') }}</h3>
              <p class="categoryoxSubTitle">Polo shirt</p>
              <div class="categoryBoxLine"
                   aria-hidden="true"></div>
            </div>
          </article>
        </div>
        <div class="categoryBoxRight">
          <article class="categoryBox"
                   :style="{ height: categoryHeight }"
                   style="background-color: #EAE6E9;">
            <div class="jacket"
                 aria-hidden="true"></div>
            <div>
              <h3 class="categoryBoxTitle">{{ $t('home.Home.bomberJacket') }}</h3>
              <p class="categoryoxSubTitle">Bomber jacket</p>
              <div class="categoryBoxLine"
                   aria-hidden="true"></div>
            </div>
          </article>
          <article class="categoryBox"
                   :style="{ height: categoryHeight }">
            <div>
              <h3 class="categoryBoxTitle">{{ $t('home.Home.parkas') }}</h3>
              <p class="categoryoxSubTitle">interchange jacket</p>
              <div class="categoryBoxLine"
                   aria-hidden="true"></div>
            </div>
            <div class="interchange"
                 aria-hidden="true"></div>
          </article>
          <article class="categoryBox"
                   :style="{ height: categoryHeight }"
                   style="background-color: #EDEDED;">
            <div class="cotton"
                 aria-hidden="true"></div>
            <div>
              <h3 class="categoryBoxTitle">{{ $t('home.Home.cotton') }}</h3>
              <p class="categoryoxSubTitle">cotton clothes</p>
              <div class="categoryBoxLine"
                   aria-hidden="true"></div>
            </div>
          </article>
        </div>
      </div>
      <div class="categoryGrid">
        <article class="categoryBox"
                 :style="{ height: categoryHeight }"
                 style="background-color: #EDEDED;">
          <div>
            <h3 class="categoryBoxTitle">{{ $t('home.Home.tshirtSeries') }}</h3>
            <p class="categoryoxSubTitle">T-shirt series</p>
            <div class="categoryBoxLine"
                 aria-hidden="true"></div>
          </div>
          <div class="tshirt"
               aria-hidden="true"></div>
        </article>
        <article class="categoryBox"
                 :style="{ height: categoryHeight }">
          <div class="tank"
               aria-hidden="true"></div>
          <div>
            <h3 class="categoryBoxTitle">{{ $t('home.Home.vestSeries') }}</h3>
            <p class="categoryoxSubTitle">TANK TOP series</p>
            <div class="categoryBoxLine"
                 aria-hidden="true"></div>
          </div>
        </article>
        <article class="sweatpants"
                 :style="{ height: categoryHeight }">
          <div>
            <h3 class="categoryBoxTitle sweatpantsTitle">{{ $t('home.Home.sweatpants') }}</h3>
            <p class="categoryoxSubTitle sweatpantsTitle">sweatpants</p>
          </div>
        </article>
      </div>
    </section>

    <!-- 素材区域 -->
    <section class="design"
             aria-label="免费素材库">
      <div class="designBg">
        <h2 class="designTitle">{{ $t('home.Home.designTitle') }}</h2>
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <p class="designEnTitle">Free material is a boon</p>
          <p class="designSubTitle">{{ $t('home.Home.designSubTitle') }}</p>
        </div>
        <div class="designImageBox">
          <Swiper ref="swiperRef"
                  :modules="modules"
                  :slides-per-view="4"
                  :loop="true"
                  :autoplay="{ disableOnInteraction: false, delay: 5000 }"
                  @swiper="onSwiper"
                  aria-label="素材轮播">
            <swiper-slide v-for="list in design_list"
                          :key="list.index"
                          :virtual-index="list.index">
              <article class="swipeDesignBox">
                <h3 class="swipeDesignTitle">{{ list.name }}</h3>
                <img :src="list.image"
                     class="swipeDesignImg"
                     :alt="list.name" />
              </article>
            </swiper-slide>
          </Swiper>
          <button class="leftIcon"
                  @click="prevClick"
                  aria-label="上一页">
            <div class="designLeftArrow"
                 aria-hidden="true"></div>
          </button>
          <button class="rightIcon"
                  @click="nextClick"
                  aria-label="下一页">
            <div class="designRightArrow"
                 aria-hidden="true"></div>
          </button>
        </div>
      </div>
    </section>

    <!-- 选择理由 -->
    <section class="reason"
             aria-label="选择我们的理由">
      <div class="reasonContent">
        <h2 class="reasonTitle">{{ $t('home.Home.reasonTitle') }}</h2>
        <p class="reasonTitleEn">Six reasons to choose</p>
        <p class="reasonSubTitle">{{ $t('home.Home.reasonSubTitle') }}</p>
      </div>
      <div class="reasonFlex"
           role="list">
        <article v-for="(item, index) in reason_list"
                 :key="index"
                 class="reasonItemFlex"
                 role="listitem">
          <img class="reasonIcon"
               :src="item.icon"
               :alt="item.name + '图标'" />
          <h3 class="reasonName">{{ item.name }}</h3>
          <p class="reasonDesc">{{ item.desc }}</p>
        </article>
      </div>
    </section>

    <!-- 定制攻略 -->
    <section class="custom"
             aria-label="定制攻略">
      <div class="customBox">
        <h2 class="customBoxTitle">{{ $t('home.Home.post') }}</h2>
        <p class="customBoxEnTitle">Custom guide</p>
        <div class="customBoxFlex"
             role="list">
          <article v-for="customData in custom_list"
                   :key="customData.index"
                   class="customTextBox"
                   @mouseover="focusCustom(customData.index)"
                   role="listitem">
            <img v-if="hoverCustom != customData.index"
                 :src="customData.img"
                 class="customImage"
                 :alt="customData.title" />
            <img v-if="hoverCustom == customData.index"
                 :src="customData.hover"
                 class="customImageHover"
                 :alt="customData.title" />
            <div v-if="hoverCustom == customData.index"
                 class="customText">
              <h3 class="customTextTtile">{{ customData.title }}</h3>
              <div class="customTextLine"
                   aria-hidden="true"></div>
              <p class="customTextContent">{{ getSimpleText(customData.content) }}</p>
            </div>
          </article>
        </div>
        <div class="customBoxBtn">
          <button class="categoryBtn"
                  @click="goCustom"
                  aria-label="查看更多攻略">
            <span>{{ $t('home.Home.goCategory') }}</span>
            <div class="icon-arrow"
                 aria-hidden="true"></div>
          </button>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section class="about"
             aria-label="关于我们">
      <div class="aboutContent">
        <div class="aboutTop">
          <div class="aboutTopTitle">
            <div v-for="(about, index) in about_list"
                 :key="index">
              <div class="aboutTopTitleBox">
                <span class="aboutTopTitle1">{{ about.name }}</span>
                <span v-if="about.subName == '+'"
                      class="aboutTopSubTitle2">{{ about.subName }}</span>
                <span v-if="about.subName == 'm'"
                      class="aboutTopSubTitle aboutTopSubTitle1">{{ about.subName }}<sup>2</sup>
                </span>
              </div>
              <p class="aboutTopTitle2">{{ about.desc }}</p>
            </div>
          </div>
          <div class="aboutTopBox">
            <h2 class="aboutTopBoxTitle">{{ $t('home.Home.aboutUs') }}</h2>
            <p class="aboutTopBoxEnTitle">about us</p>
            <p class="aboutTopBoxSubTitle">
              {{ $t('home.Home.aboutUsText1') }}<br>{{ $t('home.Home.aboutUsText2') }}<br>{{
                $t('home.Home.aboutUsText3') }}<br>{{ $t('home.Home.aboutUsText4') }}
            </p>
            <button class="aboutBtn"
                    @click="goAbout"
                    aria-label="了解更多关于我们">
              <span>{{ $t('home.Home.goCategory') }}</span>
              <div class="icon-arrow"
                   aria-hidden="true"></div>
            </button>
          </div>
          <div class="aboutTopImage">
            <div v-for="(img, index) in about_image"
                 :key="index">
              <img v-if="img.name == showAboutBg"
                   :src="img.image"
                   alt="关于我们" />
            </div>
            <div class="aboutArrow">
              <button class="leftArrow flex"
                      :class="isHover && hoverTitle == 'left' ? 'leftArrowHover' : ''"
                      @click="clickLeftArrow"
                      @mouseover="changeAbout(true, 'left')"
                      @mouseout="changeAbout(false, 'left')"
                      aria-label="上一张图片">
                <img class="arrow"
                     :src="isHover && hoverTitle == 'left' ? aboutLeft2 : aboutLeft1"
                     alt="左箭头" />
              </button>
              <button class="rightArrow flex"
                      :class="!isHover || hoverTitle == 'right' ? '' : 'rightArrowHover'"
                      @click="clickRightArrow"
                      @mouseover="changeAbout(true, 'right')"
                      @mouseout="changeAbout(false, 'right')"
                      aria-label="下一张图片">
                <img class="arrow"
                     :src="!isHover || hoverTitle == 'right' ? aboutRight1 : aboutRight2"
                     alt="右箭头" />
              </button>
            </div>
          </div>
        </div>
        <div class="aboutBg"
             aria-hidden="true"></div>
        <div v-for="(img, index) in about_data"
             :key="index"
             class="aboutData">
          <img :src="img.image"
               class="aboutImg"
               :alt="img.name" />
          <div class="aboutDataTitle">
            <span class="aboutDataTitleName">{{ img.name }}<div class="aboutDataTitleBox"
                   aria-hidden="true"></div>
            </span>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作品牌区域 -->
    <section class="footer flex-content"
             aria-label="合作品牌">
      <div class="footer-top">
        <h2 class="footerTopTitle">{{ $t('home.Home.brand') }}</h2>
        <p class="footerSubTitle">Cooperative brand</p>
        <div class="footerList"
             role="list">
          <div v-for="(list, index) in footer_list"
               :key="index"
               class="flex-item"
               role="listitem">
            <img :src="isFocus && focusIndex == index ? list.cuser : list.image"
                 @mouseover="changeImage(true, index)"
                 @mouseout="changeImage(false, index)"
                 alt="合作品牌" />
          </div>
        </div>
      </div>
      <div class="footerImage">
        <article v-for="(img, index) in footer_image"
                 :key="index">
          <img :src="img.bg"
               :alt="img.title" />
          <div class="footerImageBox">
            <div class="flex footerImageBoxItem">
              <img :src="img.icon"
                   class="footerImageBoxIcon"
                   :alt="img.title + '图标'" />
              <div>
                <h3 class="footerImageTitle">{{ img.title }}</h3>
                <p class="footerImageSubTitle">{{ img.subTtile }}</p>
              </div>
            </div>
            <!-- <button class="footerBtn"
                    @click="goAI(img.index)"
                    :aria-label="img.title + '体验'">
              <span :class="img.index == 1 ? 'aiBtnTtile' : 'mojingBtnTtile'">{{ $t('home.Home.experience') }}</span>
              <img class="footerArrow"
                   :class="img.index == 1 ? 'aiBtnArrow' : 'mojingBtnArrow'"
                   :src="img.arrow"
                   alt="箭头" />
            </button> -->
          </div>
        </article>
      </div>
    </section>

    <!-- 页脚 -->
    <footer>
      <Footer></Footer>
    </footer>
  </main>
</template>

<script setup lang="ts">
import { toUrl, getSimpleText } from "@/utils"
import { Autoplay, Pagination, Scrollbar, Navigation } from "swiper"
import "swiper/less"
import "swiper/less/autoplay" // 自动滚动
import 'swiper/less/navigation' // 轮播图两边的左右箭头
import "swiper/less/pagination" // 轮播图底面的小圆点
import { Swiper, SwiperSlide } from "swiper/vue"
import type { Swiper as SwiperClass } from 'swiper/types'
import { onMounted, ref, computed } from "vue"
import { useRouter } from "vue-router"
import { usePageSeo } from "&/composables/useSeoMeta"
import { getBanners, getMaterials, getSpus, getSectorList, getArticleFromSector } from "../api/index"
import type { bannerListType } from "../api/interface/homeinterface"
import { useHomeStore } from "../index"
import HeaderMenu from "./components/HeaderMenu.vue"
import Footer from './components/Footer.vue'
import categoryPolo from "../assets/home_image/bg_polo.png"
import categoryBg from "../assets/home_image/bg_category.png"

import teco from "../assets/home_image/ic-teco.png"
import custom from "../assets/home_image/ic-custom.png"
import sample from "../assets/home_image/ic-sample.png"
import logo from "../assets/home_image/ic-logo.png"
import one from "../assets/home_image/01.png"
import two from "../assets/home_image/02.png"
import three from "../assets/home_image/03.png"
import four from "../assets/home_image/04.png"
import productPick from "../assets/home_image/productpick.png"
import designPick from "../assets/home_image/designPick.png"
import settlePick from "../assets/home_image/settlePick.png"
import factoryPick from "../assets/home_image/factoryPick.png"
import send_time from "../assets/home_image/send_time.png"
import double_custom from "../assets/home_image/double_custom.png"
import one_order from "../assets/home_image/one_order.png"
import rapid_design from "../assets/home_image/rapid_design.png"
import service from "../assets/home_image/service.png"
import variety_goods from "../assets/home_image/variety_goods.png"

import majiang from "../assets/home_image/majiang.png"
import dog from "../assets/home_image/dog.png"
import person from "../assets/home_image/person.png"
import nature from "../assets/home_image/natrue.png"
import goodThings from "../assets/home_image/goodThings.png"
import newnew from "../assets/home_image/newnew.png"

import aboutBg2 from "../assets/home_image/aboutBg2.png"
import aboutBg3 from "../assets/home_image/aboutBg3.png"
import aboutBg4 from "../assets/home_image/aboutBg4.png"
import grs from "../assets/home_image/grs.png"
import wrap from "../assets/home_image/wrap.png"
import sgs from "../assets/home_image/sgs.png"
import gots from "../assets/home_image/gots.png"
import brand1 from "../assets/home_image/brand1.png"
import brand1_black from "../assets/home_image/brand1_black.png"
import brand2 from "../assets/home_image/brand2.png"
import brand2_black from "../assets/home_image/brand2_black.png"
import brand3 from "../assets/home_image/brand3.png"
import brand3_black from "../assets/home_image/brand3_black.png"
import brand4 from "../assets/home_image/brand4.png"
import brand4_black from "../assets/home_image/brand4_black.png"
import brand5 from "../assets/home_image/brand5.png"
import brand5_black from "../assets/home_image/brand5_black.png"
import brand6 from "../assets/home_image/brand6.png"
import brand6_black from "../assets/home_image/brand6_black.png"
import brand7 from "../assets/home_image/brand7.png"
import brand7_black from "../assets/home_image/brand7_black.png"
import brand8 from "../assets/home_image/brand8.png"
import brand8_black from "../assets/home_image/brand8_black.png"
import brand9 from "../assets/home_image/brand9.png"
import brand9_black from "../assets/home_image/brand9_black.png"
import brand10 from "../assets/home_image/brand10.png"
import brand10_black from "../assets/home_image/brand10_black.png"
import brand11 from "../assets/home_image/brand11.png"
import brand11_black from "../assets/home_image/brand11_black.png"
import brand12 from "../assets/home_image/brand12.png"
import brand12_black from "../assets/home_image/brand12_black.png"
import footerBg1 from "../assets/home_image/footerBg1.png"
import footerBg2 from "../assets/home_image/footerBg2.png"
import footerIcon1 from "../assets/home_image/footerIcon1.png"
import footerIcon2 from "../assets/home_image/footerIcon2.png"
import footerArrow1 from "../assets/home_image/footerArrow1.png"
import footerArrow2 from "../assets/home_image/footerArrow2.png"
import aboutLeft1 from "../assets/home_image/ic-about-left-black.png"
import aboutLeft2 from "../assets/home_image/ic-about-left.png"
import aboutRight1 from "../assets/home_image/ic-arrow-right.png"
import aboutRight2 from "../assets/home_image/ic-arrow-right-black.png"
import customImg1 from "../assets/home_image/custom1.png"
import customHover1 from "../assets/home_image/customHover1.png"
import customImg2 from "../assets/home_image/custom2.png"
import customHover2 from "../assets/home_image/customHover2.png"
import customImg3 from "../assets/home_image/custom3.png"
import customHover3 from "../assets/home_image/customHover3.png"
import smileImg from "../assets/home_image/ic-smile.png"
import aiImg from "../assets/home_image/ai.png"
import mirrowImg from "../assets/home_image/mirrow.png"


import { useI18n } from "vue-i18n"
import { useChatWoot } from "@huntersofbook/chatwoot-vue"
const { toggle, setLabel } = useChatWoot()
const { t } = useI18n()
// 获取系统配置
// const isHover = ref<boolean>(false)
const isClick = ref<boolean>(false)
// const productIndex = ref<number>(0)
const designIndex = ref<number>(0)
const designImage = ref<string>("")
const designImageList = ref<any[]>([])
const homeStore = useHomeStore()
const designList = ref<Array<any>>()
const slides = ref<string[]>([])
const categoryList = ref<Array<{ id: number; name: string }>>([])
const sectors = ref<typeof homeStore.sectorsList>([])

// 设置SEO元数据
usePageSeo('home')
const router = useRouter()
const btnClass = ref<string>("")
const imageRef = ref(null)
const boxRef = ref(null)
const categoryHeight = ref()
const categoryTitleRef = ref(null)
const onImageLoad = () => {
  if (imageRef.value) {
    const imageHeight = imageRef.value?.offsetHeight
    categoryHeight.value = `${imageHeight / 2}px`
  }
}
// 创建 Swiper 实例的引用
const swiperRef = ref<any>()
const onSwiper = (swiper: SwiperClass) => {
  swiperRef.value = swiper
}
const prevClick = () => {
  swiperRef.value?.$el.swiper.slidePrev()
}
const nextClick = () => {
  swiperRef.value?.$el.swiper.slideNext()
}
const custom_list = [
  {
    img: customImg1,
    hover: customHover1,
    index: 0,
    title: "",
    content: ""
  },
  {
    img: customImg2,
    hover: customHover2,
    index: 1,
    title: "",
    content: ""
  },
  {
    img: customImg3,
    hover: customHover3,
    index: 2,
    title: "",
    content: ""
  },
]
onMounted(async () => {
  productClickAll()
  materialsAll()
  bannerAll()
  homeStore.fetch().then(() => {
    categoryList.value = homeStore.categoryList
    sectors.value = homeStore.sectorsList.filter((el: any) => {
      return el.homepage_show === 1
    })
  })
  await getSectorList().then(async (res) => {
    const id = res.sectors[0].id
    if (id) {
      await getArticleFromSector(id, { limit: 3, offset: 0 }).then((article: any) => {
        for (let i = 0; i < custom_list.length; i++) {
          const index = article.rows[i] ? i : 0
          custom_list[i].title = article.rows[index].title
          custom_list[i].content = article.rows[index].content
        }
      })
    }

  })
})
console.log(111, custom_list)
const designFlag = ref<boolean>(false)
const designTitle = ref<string>("")
const changeDesign = (flag: boolean, item: string) => {
  designFlag.value = flag
  designTitle.value = item
}
const icon_list = computed(() => [
  {
    icon: one,
    title: t('home.Home.teco'),
    image: teco
  },
  {
    icon: one,
    title: t('home.Home.custom'),
    image: custom
  },
  {
    icon: one,
    title: t('home.Home.sample'),
    image: sample
  },
  {
    icon: one,
    title: t('home.Home.logo'),
    image: logo
  },
])
const process_container = computed(() => [
  {
    icon: one,
    title: t('home.Home.productPickTitle'),
    desc: t('home.Home.productPickDesc'),
    image: productPick,
    flag: "product"
  },
  {
    icon: two,
    title: t('home.Home.designPickTitle'),
    desc: t('home.Home.designPickDesc'),
    image: designPick,
    flag: "design"
  },
  {
    icon: three,
    title: t('home.Home.settlePickTitle'),
    desc: t('home.Home.settlePickDesc'),
    image: settlePick,
    flag: "settle"
  },
  {
    icon: four,
    title: t('home.Home.factoryPickTitle'),
    desc: t('home.Home.factoryPickDesc'),
    image: factoryPick,
    flag: "factory"
  }
])

const design_list = computed(() => [
  {
    image: majiang,
    name: t('home.Home.designImage1'),
    index: 0
  },
  {
    image: dog,
    name: t('home.Home.designImage2'),
    index: 1
  },
  {
    image: person,
    name: t('home.Home.designImage3'),
    index: 2
  },
  {
    image: nature,
    name: t('home.Home.designImage4'),
    index: 3
  },
  {
    image: goodThings,
    name: t('home.Home.designImage5'),
    index: 4
  },
  {
    image: newnew,
    name: t('home.Home.designImage6'),
    index: 5
  },
])

const reason_list = computed(() => [
  {
    icon: one_order,
    name: t('home.Home.oneOrderName'),
    desc: t('home.Home.oneOrderDesc'),
  },
  {
    icon: send_time,
    name: t('home.Home.sendTimeName'),
    desc: t('home.Home.sendTimeDesc'),
  },
  {
    icon: rapid_design,
    name: t('home.Home.rapidDesignName'),
    desc: t('home.Home.rapidDesignDesc'),
  },
  {
    icon: double_custom,
    name: t('home.Home.doubleCustomName'),
    desc: t('home.Home.doubleCustomDesc'),
  },
  {
    icon: variety_goods,
    name: t('home.Home.varietyGoodsName'),
    desc: t('home.Home.varietyGoodsDesc'),
  },
  {
    icon: service,
    name: t('home.Home.serviceName'),
    desc: t('home.Home.serviceDesc'),
  }
])

const about_list = computed(() => [
  {
    name: "11",
    desc: t('home.Home.aboutList1'),
    subName: "+"
  },
  {
    name: "20000",
    desc: t('home.Home.aboutList2'),
    subName: "m"
  },
  {
    name: t('home.Home.aboutList5'),
    desc: t('home.Home.aboutList3'),
    subName: "+"
  },
  {
    name: t('home.Home.aboutList6'),
    desc: t('home.Home.aboutList4')
  },
])
const about_image = computed(() => [
  {
    image: aboutBg2,
    name: "bg2"
  },
  {
    image: aboutBg3,
    name: "bg3"
  },
  {
    image: aboutBg4,
    name: "bg4"
  },
])
const showAboutBg = ref<string>("bg2")
const about_data = computed(() => [
  {
    image: grs,
    name: t('home.Home.certificate1')
  },
  {
    image: sgs,
    name: t('home.Home.certificate2')
  },
  {
    image: wrap,
    name: t('home.Home.certificate3')
  },
  {
    image: gots,
    name: t('home.Home.certificate4')
  },
])
const footer_list = [
  {
    image: brand1,
    cuser: brand1_black
  },
  {
    image: brand2,
    cuser: brand2_black
  },
  {
    image: brand3,
    cuser: brand3_black
  },
  {
    image: brand4,
    cuser: brand4_black
  },
  {
    image: brand5,
    cuser: brand5_black
  },
  {
    image: brand6,
    cuser: brand6_black
  },
  {
    image: brand7,
    cuser: brand7_black
  },
  {
    image: brand8,
    cuser: brand8_black
  },
  {
    image: brand9,
    cuser: brand9_black
  },
  {
    image: brand10,
    cuser: brand10_black
  },
  {
    image: brand11,
    cuser: brand11_black
  },
  {
    image: brand12,
    cuser: brand12_black
  },
]
const footer_image = computed(() => [
  {
    bg: footerBg1,
    title: t('home.Home.footerBg1'),
    subTtile: t('home.Home.footerTitile1'),
    icon: footerIcon1,
    arrow: footerArrow1,
    index: 1
  },
  {
    bg: footerBg2,
    title: t('home.Home.footerBg2'),
    subTtile: t('home.Home.footerTitile2'),
    icon: footerIcon2,
    arrow: footerArrow2,
    index: 2
  },
])

const hoverCustom = ref<number>(0)
const focusCustom = (flag: number) => {
  hoverCustom.value = flag
}
const isHover = ref<boolean>(false)
const hoverTitle = ref<string>("")
const changeAbout = (flag: boolean, title: string) => {
  isHover.value = flag
  hoverTitle.value = flag ? title : ""
}
const clickLeftArrow = () => {
  const index = about_image.value.findIndex(image => image.name == showAboutBg.value)
  let flag = 0
  if (index == 0) {
    flag = 2
  } else {
    flag = index - 1
  }
  showAboutBg.value = about_image.value[flag].name
}
const clickRightArrow = () => {
  const index = about_image.value.findIndex(image => image.name == showAboutBg.value)
  let flag = 0
  if (index == 2) {
    flag = 0
  } else {
    flag = index + 1
  }
  showAboutBg.value = about_image.value[flag].name
}

const isFocus = ref<boolean>(false)
const focusIndex = ref<number>(0)
const changeImage = (flag: boolean, index: number) => {
  isFocus.value = flag
  focusIndex.value = index
}

// 获取spu产品数据
const productClickAll = () => {
  btnClass.value = t('home.Home.all')
  getSpus()
    .then((result: any) => {
      // result.spus.forEach((spu: any) => {
      //   category_product.forEach((cate) => {
      //     if (spu.category.name.toUpperCase() === cate.name.toUpperCase()) {
      //       category_list.value.push(cate)
      //     }
      //   })
      // })
    })
    .catch((err) => {
      console.log(err)
    })
}
const goCustomer = () => {
  toggle("open")
  setLabel("name")
}
const goCategory = () => {
  router.push({ path: "/console/products/spus" })
}
const goCustom = () => {
  router.push({ path: "/posts" })
}
const goAbout = () => {
  router.push({ path: "/aboutus" })
}
const goAI = (index: number) => {
  index == 1 ? router.push({ path: "/AI" }) : router.push({ path: "/mirror" })
}

const designClick = (item: any) => {
  isClick.value = true
  designIndex.value = item.id
  designImage.value = item.materials[0].image
  designImageList.value = item.materials
}

// 获取素材库产品数据
const materialsAll = () => {
  getMaterials().then((result: any) => {
    designList.value = result
    if (designList.value)
      designClick(designList.value[0])
  })
}

// 获取轮播图数据
const bannerAll = () => {
  getBanners().then((result) => {
    slides.value.length = 0
    result.forEach((item: bannerListType[number]) => {
      slides.value.push(toUrl(item.image) as string)
    })
  })
}

const goDesign = () => {
  router.push({ path: "/products/custom_spus_design" })
}
const modules = [Autoplay, Pagination, Scrollbar, Navigation]


</script>

<style scoped lang="less">
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.home-content {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background-color: #f6f6f6;
  overflow-x: auto !important;
  position: relative;

  .carousel {
    position: relative;
    height: 600px;

    .swiper {
      width: 100%;
      height: 100%;

      :deep(.swiper-button-prev) {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        text-align: center;
        cursor: pointer;
        position: absolute;
        top: 50%;
        left: 20%;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.2);
        line-height: 40px;

        &:after {
          font-size: 20px;
          font-weight: 900;
        }
      }

      :deep(.swiper-button-next) {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        text-align: center;
        cursor: pointer;
        position: absolute;
        top: 50%;
        left: 80%;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.2);
        line-height: 40px;

        &:after {
          font-size: 20px;
          font-weight: 900;
        }
      }
    }

    :deep(.pagination) {
      position: absolute;
      bottom: 20px;
      z-index: 10;
      transition: opacity 0.3s;
      text-align: center;

      .swiper-pagination-bullet {
        width: 20px;
        height: 4px;
        background: rgba(255, 255, 255, 0.4);
        border-radius: 4px;
        margin: 0 5px;
        opacity: 1;
        cursor: pointer;
      }

      .swiper-pagination-bullet-active {
        width: 36px;
        background: #fff;
      }
    }
  }

  .icon {
    width: 100%;
    height: 80px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 360px;

    .icon-item {
      display: flex;
    }

    .icon-icon {
      width: 26px;
      height: 26px;
    }

    .icon-title {
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 16px;
      color: #111111;
      margin-left: 8px;
    }
  }

  .process {
    width: 100%;
    height: 800px;
    position: relative;

    .process-box {
      text-align: center;
      margin-bottom: 120px;


      .title {
        height: 48px;
        font-size: 40px;
        font-family: 'Microsoft YaHei';
        font-weight: bold;
        color: #111111;
        line-height: 48px;
        margin-top: 100px;
      }

      .title-en {
        font-family: "Microsoft YaHei";
        height: 40px;
        font-size: 14px;
        color: #999999;
        line-height: 40px;
        text-transform: uppercase;
      }

      .subtitle {
        height: 24px;
        font-size: 20px;
        color: #111111;
        line-height: 24px;
        margin-top: 20px;
        line-height: 48px;
        font-family: "Microsoft YaHei";
      }
    }

    .process-flex {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-top: 120px;
      max-height: 500px;
      padding: 0 260px;


      .process-item {
        width: 294px;
        height: 380px;
        background-color: #f6f6f6;
        position: relative;

        .process-image {
          width: 294px;
          height: 100%;
          position: absolute;
          z-index: 1000;
        }

        @keyframes move-to-position {
          0% {
            transform: translate(0, 0);
          }

          100% {
            transform: translate(0, -48px);
          }
        }

        @keyframes move-to-position-title {
          0% {
            transform: translate(0, 0);
          }

          100% {
            transform: translate(0, 36px);
          }
        }

        .process-hover {
          animation: move-to-position 1s forwards;
        }

        .process-hover-title {
          animation: move-to-position-title 1s forwards;
        }

        .process-icon {
          position: absolute;
          top: -28px;
          left: 21px;
          width: 57px;
          height: 39px;
        }

        .process-bottom {
          padding: 10px 0;
          position: absolute;
          bottom: 0;
          left: 0;
          /* z-index: -1; */

          .process-title {
            font-size: 24px;
            font-family: 'Microsoft YaHei Bold';
            font-weight: bold;
            margin: 4px 0;
          }

          .process-desc {
            width: 300px;
            overflow-wrap: break-word;
            text-overflow: ellipsis;
            color: #999;
            font-size: 14px;
            text-align: left;
            white-space: nowrap;
          }
        }
      }

      .process-design {
        /* position: absolute;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    height: 100%; */
        cursor: pointer;
      }
    }

    .process-bottom-image {
      width: 100%;
      height: 202px;
      background: url("../assets/home_image/curve.png") no-repeat;
      background-size: cover !important;
      position: absolute;
      top: 78%;
      left: 0;
    }

    .process-btn {
      width: 160px;
      height: 50px;
      margin-top: 70px;
      background: #111111;
      color: #fff;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      cursor: pointer;

      .icon-arrow {
        height: 11px;
        width: 36px;
        background: url("../assets/home_image/ic-arrow.png") no-repeat;
        background-size: cover !important;
      }
    }
  }

  .category {
    width: 100%;
    background-color: #f6f6f6;
    padding: 0 260px;
    margin-top: 100px;

    .categoryGrid {
      display: grid;
      grid-template-columns: repeat(3, 33.33%);
      width: calc(100vw - 520px);
    }

    .categoryImageBox {
      position: relative;
    }

    .categoryImage {
      width: 100%;
      height: fit-content;

    }

    .categoryBg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(17, 17, 17, 0.8);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      // .categoryTitleBox {
      //   position: relative;
      // }

      .categoryTitle1 {
        font-family: "Microsoft YaHei";
        font-weight: bold;
        font-size: 40px;
        color: #111;
        line-height: 48px;
        position: absolute;
        right: 100%;
        top: 100px;
        white-space: nowrap;
      }

      .categoryTitle {
        font-family: "Microsoft YaHei";
        font-weight: bold;
        font-size: 40px;
        color: #FFFFFF;
        line-height: 48px;
        position: absolute;
        top: 100px;
        left: 0;
      }

      .categorySubTitle {
        font-family: "Microsoft YaHei";
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 48px;
        text-transform: uppercase;
        position: absolute;
        /* left: -80px; */
        bottom: -50px;
        left: 0;
        white-space: nowrap;
      }

      .categoryBottom {
        position: absolute;
        bottom: 60px;
        right: 60px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }

      .categorySubBox {
        width: 32px;
        height: 3px;
        background: #FFFFFF;
        margin-bottom: 30px;
      }

      .categorySubBoxTitle {
        font-size: 20px;
        color: #FFFFFF;
      }

    }

    .categoryCenterImageBox {
      position: relative;
    }

    .categoryCenterImage {
      width: 100%;
      height: fit-content;

    }


    .categoryCenterBox {
      position: absolute;
      top: 47px;
      right: 47px
    }

    .categoryBox {
      width: 100%;
      background: #FFFFFF;
      padding: 0 68px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    .categoryBoxRight {
      height: 100%;
    }

    .hoodie {
      width: 156px;
      height: 160px;
      background: url("../assets/home_image/hoodie.png") no-repeat;
      background-size: cover;
    }

    .windbreaker {
      width: 156px;
      height: 160px;
      background: url("../assets/home_image/windbreaker.png") no-repeat;
      background-size: cover;
    }

    .jacket {
      width: 156px;
      height: 160px;
      background: url("../assets/home_image/jacket.png") no-repeat;
      background-size: cover;
    }

    .interchange {
      width: 175px;
      height: 228px;
      background: url("../assets/home_image/interchange.png") no-repeat;
      background-size: cover;
    }

    .cotton {
      width: 162px;
      height: 158px;
      background: url("../assets/home_image/jacket.png") no-repeat;
      background-size: cover;
    }

    .tshirt {
      width: 207px;
      height: 234px;
      background: url("../assets/home_image/tshirt.png") no-repeat;
      background-size: cover;
    }

    .tank {
      width: 112px;
      height: 160px;
      background: url("../assets/home_image/tank.png") no-repeat;
      background-size: cover;
    }

    .sweatpants {
      width: 100%;
      background: url("../assets/home_image/sweatpants.png") no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;

      .sweatpantsTitle {
        color: #fff;
      }
    }


    .cloth {
      width: 156px;
      height: 160px;
      background-size: cover;
    }

    .categoryBoxTitle {
      font-family: "Microsoft YaHei";
      font-weight: bold;
      font-size: 24px;
      color: #111111;
    }

    .categoryoxSubTitle {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      text-transform: uppercase;
    }

    .categoryBoxLine {
      width: 24px;
      height: 3px;
      background: #111111;
      margin-top: 20px;
    }
  }

  .categoryBtn {
    width: 160px;
    height: 50px;
    border: 1px solid #FFFFFF;
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;
    margin-top: 50px;

    .icon-arrow {
      height: 11px;
      width: 36px;
      background: url("../assets/home_image/ic-arrow.png") no-repeat;
      background-size: contain
    }
  }

  .categoryBtn:hover {
    font-size: 14px;
    width: 160px;
    height: 50px;
    color: #111;
    border: none;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;

    .icon-arrow {
      height: 11px;
      width: 36px;
      background: url("../assets/home_image/footerArrow2.png") no-repeat;
      background-size: contain
    }
  }

  .design {
    margin-top: 100px;
    height: 800px;

    .designBg {
      width: 100%;
      height: 300px;
      padding: 40px 260px;
      position: relative;
      display: flex;
      justify-content: space-between;

      .designTitle {
        font-weight: bold;
        font-size: 40px;
        color: #111;
        line-height: 48px;
      }

      .designEnTitle {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        text-transform: uppercase;
      }

      .designSubTitle {
        font-weight: 400;
        font-size: 20px;
        color: #111;
        margin-top: 30px;
      }

      .designArrow {
        display: flex;
        align-items: center;
      }

      .leftIcon {
        width: 50px;
        height: 50px;
        background: #EDEDED;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-right: 10px;

        .designLeftArrow {
          width: 26px;
          height: 11px;
          background: url("../assets/home_image/designArrowLeft.png") no-repeat;
          background-size: contain;
        }
      }

      .leftIcon:hover {
        background: #111;

        .designLeftArrow {
          background: url("../assets/home_image/ic-about-left.png") no-repeat;
          background-size: contain;
        }
      }

      .rightIcon {
        width: 50px;
        height: 50px;
        background: #EDEDED;

        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 1000;

        .designRightArrow {
          width: 26px;
          height: 11px;
          background: url("../assets/home_image/designArrowRight.png") no-repeat;
          background-size: contain;
        }
      }

      .rightIcon:hover {
        background: #111;

        .designRightArrow {
          background: url("../assets/home_image/ic-arrow-right.png") no-repeat;
          background-size: contain;
        }
      }

      .designImageBox {
        position: absolute;
        width: calc(100% + 60px);
        /* width: 100%; */
        height: 480px;
        top: 230px;
        left: -30px;

        :deep(.swiper-slide) {
          padding: 0 30px;
        }

        /* position: relative; */


        .swiperBox {
          /* padding: 0 260px; */
          width: calc(100% - 520px);
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-column-gap: 40px;
          overflow: hidden;
        }

        .swipeDesignBox {
          width: 100%;
          height: fit-content;
          background-color: #fff;
          margin-right: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .swipeDesignTitle {
            position: absolute;
            width: 80px;
            height: 40px;
            line-height: 40px;
            color: #fff;
            background: #003DD7;
            top: 37px;
            left: 0;
            text-align: center;
          }

          .swipeDesignImg {
            height: 280px;
            margin: 100px 0;
          }


        }
      }
    }
  }

  .reason {
    width: 100%;
    height: auto;
    padding: 0 260px;
    margin-bottom: 100px;

    .reasonContent {
      .reasonTitle {
        font-size: 40px;
        font-family: 'Microsoft YaHei Bold';
        color: #111;
        text-align: center;
      }

      .reasonTitleEn {
        font-size: 14px;
        color: #999999;
        text-transform: uppercase;
        text-align: center;
      }

      .reasonSubTitle {
        font-size: 20px;
        color: #111;
        margin: 30px 0 80px 0;
        text-align: center;
      }
    }

    .reasonFlex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      // margin-top: 50px;

      .reasonItemFlex {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .reasonIcon {
        width: 48px;
        height: 48px;
      }

      .reasonName {
        height: 48px;
        line-height: 48px;
        font-size: 20px;
        font-family: 'Microsoft YaHei Bold';
        color: #111;
        margin-top: 20px;
      }

      .reasonDesc {
        width: 170px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #999999;
        overflow-wrap: break-word;
      }
    }
  }

  .custom {
    width: 100%;
    height: 763px;
    background: url("../assets/home_image/customBg.png") repeat-x;
    background-size: cover !important;
    position: relative;

    .customBox {
      background-color: rgba(17, 17, 17, 0.2);
      position: absolute;
      top: 0;
      left: 0;
      text-align: center;
      width: 100%;
      padding: 0 260px;

      .customBoxTitle {
        color: #fff;
        font-weight: bold;
        font-size: 40px;
        margin-top: 100px;
      }

      .customBoxEnTitle {
        color: #999;
        font-size: 14px;
        text-transform: uppercase;
        margin-bottom: 60px;
      }
    }

    .customBoxBtn {
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }

    .customBoxFlex {
      display: flex;
      justify-content: space-between;
      /* transition: all 1s; */

      .customTextBox {
        cursor: pointer;
        position: relative;
        width: 360px;
        height: 330px;
        overflow: hidden;
        transition: width 0.6s ease;

        /* 默认图片样式 */
        .customImage,
        .customImageHover {
          position: absolute;
          top: 0;
          left: 0;
          width: 360px;
          height: 330px;
          transition: all 0.6s ease;
        }

        /* 文字框样式 */
        .customText {
          position: absolute;
          top: 0;
          left: 0;
          width: 600px;
          height: 330px;
          background: rgba(9, 45, 134, 0.9);
          display: flex;
          flex-direction: column;
          justify-content: center;
          opacity: 0;
          transition: all 0.6s ease;

          .customTextTtile {
            height: 100px;
            line-height: 100px;
            color: #FFFFFF;
            font-size: 24px;
            text-align: start;
            margin: 0 40px;
          }

          .customTextLine {
            height: 1px;
            background: rgba(255, 255, 255, 0.45);
          }

          .customTextContent {
            height: 150px;
            color: #FFFFFF;
            font-size: 14px;
            line-height: 30px;
            text-align: start;
            margin: 40px;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5;
            /* 这里是超出几行省略 */
            overflow: hidden;
          }
        }
      }

      /* 所有customTextBox初始状态 */
      .customTextBox {
        width: 360px;
      }

      /* 当前hover的customTextBox样式 */
      .customTextBox:has(.customText:not(:empty)) {
        width: 600px;
      }

      /* 图片过渡效果 */
      .customTextBox:has(.customText:not(:empty)) .customImage {
        opacity: 0;
        transform: translateX(-100%);
      }

      /* 悬停图片过渡效果 */
      .customTextBox:has(.customText:not(:empty)) .customImageHover {
        width: 600px;
      }

      /* 文字框显示效果 */
      .customTextBox:has(.customText:not(:empty)) .customText {
        opacity: 1;
      }


    }
  }

  .about {
    .aboutContent {
      width: 100%;
      height: 748px;
      background: #EDEDED;
      margin-top: 770px;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding: 0 260px;

      .aboutBg {
        position: absolute;
        top: 170px;
        left: 0;
        width: 1018px;
        height: 155px;
        background: url("../assets/home_image/aptitude.png") repeat-x;
        background-size: cover !important;
      }

      .aboutData {
        margin-bottom: 60px;
        z-index: 1000;

        .aboutImg {
          max-width: 260px;
          max-height: 340px;
          width: fit-content;
          height: fit-content;
        }

        .aboutDataTitle {
          display: flex;
          justify-content: center;

          .aboutDataTitleName {
            width: fit-content;
            font-size: 20px;
            color: #111111;
            position: relative;
          }

          .aboutDataTitleBox {
            width: 24px;
            height: 6px;
            background: #003DD7;
            position: absolute;
            bottom: 6px;
            left: -10px;
          }

        }
      }
    }

    .aboutTop {
      position: absolute;
      top: -770px;
      left: 0;
      width: 100%;
      height: 870px;
      padding: 0 260px;

      .aboutTopTitle {
        height: 300px;
        margin-top: 100px;
        display: flex;
        justify-content: space-around;
        padding-top: 60px;
        background: url("../assets/home_image/aboutBg1.png") repeat-x;
        background-size: cover !important;
      }

      .aboutTopTitleBox {
        position: relative;
        display: flex;
        align-items: flex-start;
      }

      .aboutTopTitle1 {
        font-weight: bold;
        font-size: 56px;
        color: #003DD7;
        line-height: 66px;
      }

      .aboutTopSubTitle {
        color: #003DD7;
        color: #003DD7;
        font-weight: bold;
        /* line-height: 42px; */
      }

      .aboutTopSubTitle2 {
        font-size: 32px;
        color: #003DD7;
        font-weight: bold;
        line-height: 42px;
      }

      .aboutTopSubTitle1 {
        position: absolute;
        bottom: 0px;
        right: -36px;
        font-size: 24px;

      }

      .aboutTopTitle2 {
        font-weight: bold;
        font-size: 18px;
        color: #111111;
        margin-top: 14px;
      }

      .aboutTopBox {
        width: 1040px;
        height: 550px;
        background: #fff;
        position: absolute;
        bottom: 0;
        padding: 100px 60px;

        .aboutTopBoxTitle {
          font-weight: bold;
          font-size: 40px;
          color: #111111;
        }

        .aboutTopBoxEnTitle {
          color: #999;
          font-size: 14px;
          text-transform: uppercase;
          margin: 12px 0 30px 0;
        }

        .aboutTopBoxSubTitle {
          font-size: 20px;
          color: #111111;
          line-height: 42px;
        }

        .aboutBtn {
          color: #fff;
          background-color: #111;
          width: 160px;
          height: 50px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          cursor: pointer;
          margin-top: 60px;

          .icon-arrow {
            height: 11px;
            width: 36px;
            background: url("../assets/home_image/ic-arrow.png") no-repeat;
            background-size: contain;
          }
        }


      }

      .aboutTopImage {
        position: absolute;
        bottom: -70px;
        right: 0;
        width: 797px;
        height: 520px;

        img {
          width: 797px;
          height: 520px;
        }

        .aboutArrow {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;

          .flex {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .arrowDiv {
            width: 1px;
            background-color: #f6f6f6;
          }

          .leftArrow {
            width: 50px;
            height: 50px;
            background: #EDEDED;
            cursor: pointer;

            .arrow {
              height: 11px;
              width: 26px;

            }
          }

          .leftArrowHover {
            background: #111;
          }

          .leftArrowOut {
            background: #EDEDED;
          }

          .rightArrowOut {
            background: #EDEDED;
          }


          .rightArrow {
            width: 50px;
            height: 50px;
            background: #111;
            cursor: pointer;

            .arrow {
              height: 11px;
              width: 26px;
              cursor: pointer;
              background: url("../assets/home_image/ic-arrow-right-black.png") no-repeat;
              background-size: contain;
            }
          }

          .rightArrowHover {
            background: #EDEDED;
          }
        }
      }
    }
  }

  .footer {
    .footer-top {
      width: 100%;
      height: 600px;
      padding: 100px;

      .footerTopTitle {
        font-weight: bold;
        font-size: 40px;
        color: #111111;
        text-align: center;
      }

      .footerSubTitle {
        font-size: 14px;
        color: #999999;
        line-height: 48px;
        text-transform: uppercase;
        margin: 14px 0 100px 0;
        text-align: center;
      }

      .footerList {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        justify-self: center;
        align-items: baseline;
        width: 100%;
        height: 260px;

        .flex-item {
          width: 16.6%;
          display: flex;
          justify-content: center;
        }

        img {
          max-height: 48px;
          max-width: 130px;
        }
      }
    }

    .footerImage {
      display: flex;
      position: relative;
      height: 200px;

      img {
        width: 50vw;
        height: 200px;
      }

      .footerImageBox {
        position: absolute;
        top: 0;
        bottom: 0;
        padding-left: 180px;
        padding-top: 20px;
        display: flex;
        justify-content: space-between;
        width: 50vw;
        height: 100%;

        .footerImageBoxItem {
          margin-top: 40px;
        }

        .footerImageBoxIcon {
          max-height: 47px;
          width: fit-content;
          max-width: 54px;
          height: fit-content;
          margin-right: 20px;
        }

        .footerImageTitle {
          font-weight: bold;
          font-size: 32px;
          color: #FFFFFF;
          line-height: 32px;
        }

        .footerImageSubTitle {
          font-size: 20px;
          line-height: 20px;
          color: #FFFFFF;
          margin-top: 20px;
        }

        .aiBtnTtile {
          color: #003DD7;
          font-weight: bold;
        }

        .footerArrow {
          width: fit-content;
          height: 100%;
        }

        .aiBtnArrow {
          color: #003DD7;
        }

        .mojingBtnTtile {
          color: #111;
          font-weight: bold;
        }

        .mojingBtnArrow {
          color: #111;
        }
      }
    }

    .flex {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
  }

  .flex-content {
    display: flex;
    // justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .dialog-box {
    position: fixed;
    bottom: 100px;
    left: calc(100vw - 100px);
    width: 80px;
    height: 70px;
    background: #003DD7;
    border-radius: 8px;
    border-top-left-radius: 0;
    padding: 8px;
    box-shadow: 0 5px 18px 10px rgba(0, 61, 215, 0.2);
    /* position: relative; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    cursor: pointer;

    .smile-img {
      width: 16px;
      height: 12px;
      margin-bottom: 10px;
    }
  }

  /* 盒子内文字样式（可选） */
  .dialog-text {
    font-size: 14px;
    color: #fff;
  }

  /* 左上角三角：内部填充部分（覆盖边框，露出盒子背景色） */
  .dialog-box::after {
    content: '';
    position: absolute;
    top: 0px;
    left: -10px;
    border-width: 12px 0 12px 12px;
    border-top-left-radius: 5px;
    border-style: solid;
    border-color: #003DD7 transparent transparent transparent;
  }
}

/* 适用于 Chrome、Safari 和 Opera */
.home-content::-webkit-scrollbar {
  display: none;
}

/* 适用于 IE 和 Edge */
.home-content {
  -ms-overflow-style: none;
}

/* 适用于 Firefox */
.home-content {
  scrollbar-width: none;
}

// @media only screen and (max-width: 1800px) and (min-width: 1600px) {
//   .home-content {
//     zoom: 90%;
//   }
// }

// @media only screen and (max-width: 1600px) and (min-width: 1400px) {
//   .home-content {
//     zoom: 80%;
//   }
// }

// @media only screen and (max-width: 1400px) {
//   .home-content {
//     zoom: 70%;
//   }
// }</style>
